import React, { Component } from "react"
import { NavLink } from "react-router-dom"

class LeftNav extends Component {
  render() {
    return (
      <aside className="left-sidebar">
        <div className="scroll-sidebar">
          <nav className="sidebar-nav">
            <ul id="sidebarnav">
              <li>
                <NavLink to="/" exact className="waves-effect waves-dark" activeClassName="active">
                  <span className="hide-menu">Dashboard 1</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/dashboard2"
                  className="waves-effect waves-dark"
                  activeClassName="active"
                >
                  <span className="hide-menu">Dashboard 2</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/some-unknown-page-sudijfhisdf"
                  className="waves-effect waves-dark"
                  activeClassName="active"
                >
                  <span className="hide-menu">Error 404</span>
                </NavLink>
              </li>
            </ul>
          </nav>
        </div>
        <div className="sidebar-footer"> </div>
      </aside>
    )
  }
}

export default LeftNav



// WEBPACK FOOTER //
// ./src/Components/Layout/LeftNav.js